export default "__VITE_ASSET__DSKNtgjK__"